import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "StackedScrolling2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M24 12H22.5V3H16.5V1.5H22.5C23.3284 1.5 24 2.17157 24 3V12ZM18.75 15.75H20.25V6.75C20.25 5.92157 19.5784 5.25 18.75 5.25H12.75V6.75H18.75V15.75ZM1.5 22.5H6C6.82843 22.5 7.5 21.8284 7.5 21V10.5C7.5 9.67157 6.82843 9 6 9H1.5C0.671573 9 0 9.67157 0 10.5V21C0 21.8284 0.671573 22.5 1.5 22.5ZM1.5 21V10.5H6V21H1.5ZM10.5 22.5C9.67157 22.5 9 21.8284 9 21V10.5C9 9.67157 9.67157 9 10.5 9H15C15.8284 9 16.5 9.67157 16.5 10.5V21C16.5 21.8284 15.8284 22.5 15 22.5H10.5ZM10.5 21V10.5H15V21H10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/StackedScrolling2.vue"]]);
